const CACHE_CONFIG = {
  EXPRIE_TIME: 7 * 24 * 60 * 60 * 1000,
  VERSION: process.env.VUE_APP_STORAGE_VERSION == null ? "0.0" : process.env.VUE_APP_STORAGE_VERSION
};
const CACHE_KEY = {
  TOKEN: "TOKEN",
  USERINFO: "USERINFO"
};
const default_cache = {
  version: CACHE_CONFIG.VERSION,
  date: Date.now()
};
const cache = {
  default_cache,
  CACHE_KEY,
  CACHE_CONFIG,
  init: key => {
    var nowCache = cache.getFromStorage(key);
    if (cache.isSameVersion(nowCache) && !cache.isExprie(nowCache)) {
      cache.default_cache = nowCache;
    }
    cache.setIntoStorage(key, cache.default_cache);
  },
  get: key => {
    var nowCache = cache.getFromStorage(key);
    if (cache.isSameVersion(nowCache) && !cache.isExprie(nowCache)) {
      return nowCache[key];
    }
    return null;
  },
  set: (key, value) => {
    var nowCache = cache.getFromStorage(key);
    if (!nowCache) {
      nowCache = cache.default_cache;
    }
    nowCache.date = Date.now();
    nowCache.version = cache.CACHE_CONFIG.VERSION;
    nowCache[key] = value;
    cache.setIntoStorage(key, nowCache);
  },
  setIntoStorage: (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
  },
  getFromStorage: key => {
    var str = localStorage.getItem(key);
    if (str) {
      return JSON.parse(str);
    }
    return null;
  },
  isSameVersion: nowCache => {
    if (!nowCache) {
      return true;
    }
    var nowVersion = nowCache.version;
    return nowVersion && nowVersion === cache.CACHE_CONFIG.VERSION;
  },
  isExprie: nowCache => {
    if (!nowCache) {
      return true;
    }
    var nowDateTime = nowCache.date;
    return nowDateTime && Date.now() - nowDateTime > cache.CACHE_CONFIG.EXPRIE_TIME;
  },
  clear: key => {
    if (key) {
      localStorage.removeItem(key);
    } else {
      localStorage.clear();
    }
  }
};
cache.init(cache.CACHE_KEY.TOKEN);
cache.init(cache.CACHE_KEY.USERINFO);
export default cache;
